module.exports = __webpack_public_path__ + "img/hualongcaixian.ee09634e.png";